<template>
  <div>
    <HeaderComponent :headerTitle="headerText" />
    <loading v-model:active="loading"
        :can-cancel="true"
        :color="primary_code"
        :is-full-page="mainFullPage"/>
    <v-container fluid grid-list-lg pt-0>
      <div class="ifame_container">
        <iframe :src="decodeURL" width="100%" class="ifame-dashboard" @load="loading = false"></iframe>
      </div>
    </v-container>
  </div>
</template>
<script>
import HeaderComponent from "../../../../commoncomponents/HeaderComponent";
import Loading from 'vue-loading-overlay';
export default {
  data() {
    return {
      headerText: "Per Unit Cost",
      iframeUrl: '',
      localUrl: '',
      decodeURL:'',
      loading: false,
      primary_code: "#0275d8",
      mainFullPage : true
    };
  },
  components: {
    HeaderComponent,Loading
  },
  mounted() {
    this.fetchIframeUrl();
  },
  computed: {
    displayUrl() {
      return this.iframeUrl || this.localUrl;
    },
  },
  methods: {
    fetchIframeUrl() {
      this.loading = true;
      this.$httpSecured
        .get("/api/v2/dashboard/dashboard_embed_url?dashboard=12")
        .then((response) => {
          if (response.data) {
            this.iframeUrl = response.data.embed_url;
            this.decodeURL = decodeURI(this.iframeUrl);
            this.loading = true;
          } else {
            this.showAlert("error", "No Data Found");
            this.loading = false;
          }
        })
        .catch((error) => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
  },
};
</script>
<style>
.ifame_container {
  width: 99% !important;
}

.ifame-dashboard {
  height: 85vh !important;
  border: none;
  border-radius: 15px;
  --webkit-border-radius: 15px;
}
</style>
